import Head from "next/head";
import LandingPage from "@web/src/components/landing/landing-page";
import {
  homepageJsonLd,
  jsonLdScript,
} from "@web/src/lib/agent/structured-data";
import { absoluteUrl, SITE } from "@web/src/lib/agent/site";

const TITLE = `${SITE.fullName} — ${SITE.tagline}`;

export default function Home() {
  return (
    <>
      <Head>
        <title>{TITLE}</title>
        <meta name="description" content={SITE.shortDescription} />
        <meta name="application-name" content={SITE.name} />
        <link rel="canonical" href={absoluteUrl("/")} />
        <link
          rel="alternate"
          type="text/markdown"
          href={absoluteUrl("/")}
          title="Markdown (Accept: text/markdown)"
        />
        <link
          rel="alternate"
          type="text/plain"
          href={absoluteUrl("/llms.txt")}
          title="llms.txt"
        />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={SITE.fullName} />
        <meta property="og:title" content={TITLE} />
        <meta property="og:description" content={SITE.shortDescription} />
        <meta property="og:url" content={absoluteUrl("/")} />
        <meta property="og:image" content={absoluteUrl("/icon-512.png")} />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={TITLE} />
        <meta name="twitter:description" content={SITE.shortDescription} />
        <meta name="twitter:image" content={absoluteUrl("/icon-512.png")} />

        <script
          type="application/ld+json"
          // Structured identity for agents: SoftwareApplication + Organization
          // + WebSite. Serialised through a helper that escapes `<`.
          dangerouslySetInnerHTML={{
            __html: jsonLdScript(homepageJsonLd()),
          }}
        />
      </Head>
      <LandingPage />
    </>
  );
}
